 import React from 'react';
import { Link, Redirect } from 'react-router-dom';

import { PrimaryButton } from 'Components/Button';
import {
    FormHandler, Input, FileUpload, Select, Checkbox, Textarea,
} from 'Components/Form';
import {Alert, Loading} from 'Components/Partials';
import {MailLink} from 'Components/Utilities';

import {getFallbackAvatarUrl} from 'Services/AuthHelpers';
import Me from 'Services/Api/Me/Me';

import AdminLayout from 'Pages/Admin/AdminLayout';
import Authenticated from "Components/Layouts/Authenticated";


class Profile extends React.Component {
    /**
     * @var success
     * @type {string}
     */
    success = 'Your details have been updated successfully';

    /**
     * @var displayAvatar
     * @type {boolean}
     */
    displayAvatar = true;

    /**
     * @var state
     */
    state = {
        loading: true,
        user_id: this.props.match?.params?.user ?? null,
        invitesShown: [],
        phase: 'form',
        hotelOptions: [],
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.loadUser();
        //this.loadHotels();
    };

    /**
     * @method loadUser
     */
    loadUser = async () => {
        const {user_id} = this.state;

        // Start loading.
        this.setState({
            loading: true
        });

        // Request the data.
        const response = await Me.getMe({
            includeHasInvited: true,
            user_id
        });

        // Increment the invites array keys as we are 1 based for this form.
        let invites = [];

        if (response.data.data.has_invited) {
            //invites[0] = response.data.data;
            for (var i=0; i < response.data.data.has_invited.length; i++) {
                invites[i] = response.data.data.has_invited[i] ;
            }
        }

        // if (response.data.data.has_invited.length === 0 && response.data.data.number_of_invites > 0) {
        //     //invites[0] = response.data.data;
        //
        //     for (var i=0; i < response.data.data.number_of_invites; i++) {
        //         invites[i] = [];
        //     }
        // }

        // if(response.data.data.number_of_invites > response.data.data.has_invited.length){
        //     for (var i= invites.length; i < response.data.data.number_of_invites; i++) {
        //         invites[i] = [];
        //         response.data.data.has_invited[i] = [];
        //     }
        // }



        // Set the form values.
        this.props.setForm({
            ...response.data.data,
            invites,
            user_id
        });

        // Finish loading.
        this.setState({
            loading: false
        });
    }

    /**
     * @method getFormValues
     * @param {integer|null} index
     * @return {object}
     */
    getFormValues = (index) => {
        const {form} = this.props;

        return index !== null ?
            (form['invites'] && form['invites'][index] ?
                form['invites'][index] :
                null) :
            form;
    }

    /**
     * @method getFormkey
     * @param {integer|null} index
     * @return {string}
     */
    getFormkey = (index) => {
        return index !== null ?
            'invites.' + index + '.' :
            '';
    }

    /**
     * @method handleToggleInvite
     * @param {integer} index
     */
    handleToggleInvite = (index) => {
        const {invitesShown} = this.state;
        this.setState({
            invitesShown: {
                ...invitesShown,
                [index]: !invitesShown[index]
            }
        });
    }

    /**
     * @method handleSuccess
     */
    handleSuccess = () => {
        this.handlePhaseChange('success');
    }

    /**
     * @method handlePhaseChange
     * @param {string} phase
     */
    handlePhaseChange = (phase) => {
        this.loadUser();

        this.setState({
            phase
        });
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {user_id, phase} = this.state;

        if (user_id) {
            return (
                <AdminLayout title='Users - Profile'>
                    {this.renderPhase()}
                </AdminLayout>
            );
        }

        return (
            <Authenticated pageTitle="Who's Who" headerImage={'/images/headers/whos-who.png'} showRegBanner={false}>
                <div className={"mx-auto max-w-7xl"}>
                    { this.renderPhase () }
                </div>
            </Authenticated>
        );
    }

    /**
     * @method renderPhase
     * @return {JSX.Element}
     */
    renderPhase() {
        const {phase} = this.state;

        if (phase === 'success') {
            // redirect to the whos-whos page
            return <Redirect to="/attendees" />;
        }

        return this.renderPage();
    }

    toggleFilter = () => {
        this.setState({
            networking_opt_out: !this.state.networking_opt_out,
        });
    }

    /**
     * @method renderPage
     * @return {JSX.Element}
     */
    renderPage () {
        const {loading} = this.state;
        const {form, working, alert, handleInput, handleSubmit, getFieldError} = this.props;

        if (loading) {
            return <Loading />;
        }

        return (
            <form
                autoComplete="off"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(e, Me.update, this.handleSuccess);
                    window.scrollTo(0, 0);
                }}
            >
                {alert !== null && (<Alert {...alert} />)}

                <div className="text-center font-light mt-8 mb-4">

                    {(((form.has_invited && form.has_invited.length) > 0) || (form.has_invited !== [] && form.number_of_invites > 0)) &&
                        <>
                            <p className="text-center font-light mb-4 mt-8">
                                You
                                have {form.number_of_invites > 0 ? form.number_of_invites : form.has_invited.length} {" "}
                                invites for your store. This allocation includes yourself (Store Manager).
                            </p>

                        </>
                    }


                    {/*<p className="font-bold text-lg">*/}
                    {/*    Please click*/}
                    {/*    {" "}*/}
                    {/*    <Link*/}
                    {/*        to="/venues"*/}
                    {/*        target="_blank"*/}
                    {/*        className="underline"*/}
                    {/*    >*/}
                    {/*        here*/}
                    {/*    </Link>*/}
                    {/*    { " " } to view the venue information.*/}
                    {/*</p>*/}

                    {/*form?.venue &&
                        <p className="font-bold text-lg">
                            {form?.venue}
                        </p>
                    */}
                </div>

                <div className="p-6 space-y-6">
                    {/*{alert !== null && (<Alert {...alert} />)}*/ }

                    { this.displayAvatar &&
                        <FileUpload
                            containerClassName="m-8 mt-4 flex flex-col justify-center items-center gap-4"
                            value={ form.avatar_path }
                            onChange={ v => handleInput ( 'avatar_path', v ) }
                            accept="image/*"
                            placeholder="Update Picture"
                            fallbackImage={ getFallbackAvatarUrl ( form ) }
                        />
                    }

                    <Input
                        labelColour={ "text-app-blue" }
                        label={"First Name"}
                        placeholder="First Name"
                        value={ form?.first_name }
                        id="first_name"
                        error={ getFieldError ( 'first_name' ) }
                        onChange={ ( v ) => handleInput ( 'first_name', v ) }
                        containerClassName={ "col-span-2 md:col-span-1" }
                    />

                    <Input
                        labelColour={ "text-app-blue" }
                        label={"Last Name"}
                        placeholder="Last Name"
                        value={ form?.last_name }
                        id="last_name"
                        error={ getFieldError ( 'last_name' ) }
                        onChange={ ( v ) => handleInput ( 'last_name', v ) }
                        containerClassName={ "col-span-2 md:col-span-1" }
                    />

                    <Input
                        labelColour={ "text-app-blue" }
                        label={"Company"}
                        placeholder="Company"
                        value={ form?.company_name }
                        id="company_name"
                        error={ getFieldError ( 'company_name' ) }
                        onChange={ ( v ) => handleInput ( 'company_name', v ) }
                        containerClassName={ "col-span-2 md:col-span-1" }
                    />

                    <Input
                        labelColour={ "text-app-blue" }
                        label={"Your Job Title"}
                        placeholder="Job Title"
                        value={ form?.job_title }
                        id="job_title"
                        error={ getFieldError ( 'job_title' ) }
                        onChange={ ( v ) => handleInput ( 'job_title', v ) }
                        containerClassName={ "col-span-2 md:col-span-1" }
                    />

                    <Input
                        labelColour={ "text-app-blue" }
                        label={"LinkedIn Profile URL"}
                        placeholder="LinkedIn Profile URL"
                        value={ form?.linkedin }
                        id="linkedin"
                        error={ getFieldError ( 'linkedin' ) }
                        onChange={ ( v ) => handleInput ( 'linkedin', v ) }
                        containerClassName={ "col-span-2 md:col-span-1" }
                    />

                    {/*<Textarea*/}
                    {/*    placeholder="Tell us something about yourself"*/}
                    {/*    value={ form?.bio }*/}
                    {/*    id="bio"*/}
                    {/*    error={ getFieldError ( 'bio' ) }*/}
                    {/*    onChange={ ( v ) => handleInput ( 'bio', v ) }*/}
                    {/*    containerClassName={ "col-span-2 md:col-span-1" }*/}
                    {/*/>*/}

                    {/*HACKY QUICK FIX: networking_opt_out = true, is equivelant of opting in*/ }
                    <div className="my-auto py-4 text-white">
                        <Checkbox
                            label={ "I am happy to connect with other attendees" }
                            value={ form.consent_networking === true }
                            id="consent_networking"
                            error={ getFieldError ( 'consent_networking' ) }
                            onChange={ ( v ) => handleInput ( 'consent_networking', v ) }
                            containerClassName={ "font-bold text-2xl" }
                            className={ "font-bold text-xl " }
                            textColor={ "text-white" }
                        />
                    </div>

                    {/*<div className="my-auto py-4 text-white">*/}
                    {/*    <Checkbox*/}
                    {/*        label={ "I confirm that I am happy that my contact details are visible to other attendees" }*/}
                    {/*        value={ form.contact_details_opt_in === true }*/}
                    {/*        id="contact_details_opt_in"*/}
                    {/*        error={ getFieldError ( 'contact_details_opt_in' ) }*/}
                    {/*        onChange={ ( v ) => handleInput ( 'contact_details_opt_in', v ) }*/}
                    {/*        containerClassName={ "font-bold text-2xl" }*/}
                    {/*        className={ "font-bold text-xl " }*/}
                    {/*        textColor={ "text-white" }*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>

                <div className="p-6 flex justify-between">
                    <PrimaryButton
                        text="Save"
                        working={ working }
                        type="submit"
                    />
                </div>

                <div className="p-6 font-light text-white">
                    <p>
                        If you have any questions about the event, please contact <MailLink to="info@whitbreadseniorleaders.com" />
                    </p>
                </div>
            </form>
        );
    }


    restAdvisorForm( index, key ) {
        const { handleInput } = this.props;

        //only way for the reset form to work. Manually do it
        handleInput ( key + 'employee_number', null);
        handleInput(key + 'first_name', null);
        handleInput(key + 'last_name', null);
        handleInput(key + 'position', null);
        handleInput(key + 'accommodation', null);
        handleInput(key + 'accommodation_postcode', null);
        handleInput(key + 'dietaries', null);
        handleInput(key + 'special_access_requirements', null);
        handleInput(key + 'emergency_contact_details', null);
        handleInput(key + 'travel', null);
        handleInput(key + 'reason_can_not_attend', null);

        this.props.form.invites[index]=null;
        delete this.props.form.invites[index];
    }

    //  isAttending( values ) {
    //     const {form} = this.props;
    //
    //     if(values?.reason_can_not_attend === null && form?.profile_completed === null) {
    //         return null;
    //     }
    //
    //     if(values?.attending) {
    //         return true;
    //     }
    //
    //     return false;
    // }



    /**
     * @method renderSuccess
     * @return {JSX.Element}
     */
    renderSuccess() {
        const {form} = this.props;

        return (
            <div className="text-center mt-8">
                {form.first_group_name === 'Store Manager' && !form.profile_completed &&
                    <>
                        {/*<p className="font-bold mb-4">*/}
                        {/*    Thank you!*/}
                        {/*</p>*/}
                        <p className="mb-4">
                            Make sure you return to the site to complete all the advisors details for the event.
                            You can do this until Friday 8th March.
                        </p>
                    </>
                }

                {form.first_group_name === 'Store Manager' && form.profile_completed &&
                    <p className="font-bold mb-4">
                         You have successfully registered your advisors for the No7 event.
                    </p>
                }

                {form.first_group_name === 'Store Manager' && form['invites'].length > 0 && form.profile_completed && (

                    <table className={"mx-auto border-spacing-3 border "} key={"userInviteTable"}>
                        <thead>
                                <tr>
                                    <th className={ "p-4" }>Type</th>
                                    <th className={ "p-4" }>First Name</th>
                                    <th className={ "p-4" }>Last Name</th>
                                    <th className={ "p-4" }>Store Number</th>
                                    <th className={ "p-4" }>Employee Number</th>
                                    {/*<th className={ "p-4" }>Hotel Reservation</th>*/}
                                </tr>
                            </thead>
                        <tbody>
                            {form['invites']
                                .map((invite, index) => (
                                    <>
                                    {invite.attending === false  && (
                                        <tr className={"mx-auto"}>
                                            <td colSpan={4} className={"p-4 span-5 text-left"}>{ index === 0 ? 'Store/Deputy Manager not attending' : 'Advisor ' + index + ' not attending'}</td>
                                        </tr>
                                    )}
                                        {invite.attending === true && (
                                            <tr className={ "mx-auto" }>
                                            {index < 1 && (
                                                <td className={ "p-4" }>{ invite?.invite_type === 'Advisor' ?  'Store Manger ' : invite?.invite_type  }</td>
                                            ) }
                                                {index >= 1 && (
                                                    <td className={ "p-4" }>{ 'Advisor ' + index }</td>
                                                ) }
                                                <td className={ "p-4" }>{ invite.first_name }</td>
                                            <td className={ "p-4" }>{ invite.last_name }</td>
                                            <td className={ "p-4" }>{ invite.store_number }</td>
                                            <td className={ "p-4" }>{ invite.employee_number }</td>
                                                {/*<td className={ "p-4" }>{ invite.reservations?.hotel.name ?? 'No Hotel Booked' }</td>*/}
                                        </tr>
                                        ) }
                                </>
                                ) ) }
                        </tbody>
                    </table>
                )}

                {form.first_group_name !== 'Store Manager' &&
                    <p className="font-bold mb-4 text-white">
                        You have successfully registered to attend the Event.'
                    </p>
                }

                {((form.attending === true  && form.first_group_name !== 'Store Manager')  ||  form.profile_completed === true && form.first_group_name === 'Store Manager')  && (
                    <>
                        <p className="mb-4">
                            A confirmation email has been sent to your email address.
                        </p>
                        <p className="font-light mb-4">
                            If you do not see the email in a few minutes,
                            please check your junk inbox in case it has slipped into this folder.
                        </p>

                        <p>
                            Joining instructions will be sent with additional venue and event information on Thursday
                            14th March.
                            Please see <Link to={"/venues"} class={"underline"}> here </Link> for further information on
                            the venue and travel.
                        </p>
                    </>
                )}
                {/*{ form.profile_completed && (*/}
                {/*    <p className="font-light mb-4">*/}
                {/*        A confirmation email has been sent to your email address.*/}
                {/*    </p>*/}
                {/*)}*/}

                {/*{form.first_group_name === 'Store Manager' && form.profile_completed === false &&
                    <>
                        <p>
                            Joining instructions will be sent with additional venue and event information on Wednesday 1st March 2023.
                            Please see <Link to="/venues" className="underline cursor-pointer">here</Link>{" "}
                            for further information on the venue and travel.
                        </p>
                    </>
                }*/}

                <p className="font-light mb-8 text-white">
                    If you have any questions about the event, please contact <MailLink to="info@whitbreadseniorleaders.com" />
                </p>

                <PrimaryButton
                    text="Update"
                    onClick={() => this.handlePhaseChange('form')}
                />
            </div>
        );
    }
}

export default FormHandler(Profile);
